"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
const offline_query_resolver_1 = __importDefault(require("./offline-query-resolver"));
/**
 * Resolves queries using 18nPriceFormat type features.
 */
class PriceFormatQueryResolver extends offline_query_resolver_1.default {
    getTargetConfigType() {
        return PriceFormatQueryResolver.TARGET_CONFIG_TYPE;
    }
    validate(attributeName, args) {
        // Verify if configType matches between attributeName and the args.
        // For the PriceFormatQueryResolver, we want to verify the args configType
        // to match the specific target type, like retail etc.
        if (attributeName.getConfigType() !== this.getTargetConfigType()
            || args.getConfigType() !== this.getSpecificArgsTargetConfigType()) {
            throw new Error(this.getValidationErrorMessage());
        }
    }
}
exports.default = PriceFormatQueryResolver;
PriceFormatQueryResolver.TARGET_CONFIG_TYPE = i18n_configuration_provider_1.ConfigType.PRICE_FORMAT;
//# sourceMappingURL=price-format-query-resolver.js.map